<template>
  <b-container>
      <b-row>
    <b-col>
   Manage Tiers
        </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">
        <b-button
          size="sm"
          @click="group_add"
          :disabled="!tier_name || $parent.event.groups.length > 2"
          variant="primary"
        >
          Add Tier
        </b-button>
      </b-col>
      <b-col>
        <span>
          <b-input placeholder="Tier Name" v-model="tier_name"> </b-input>
        </span>
      </b-col>
    </b-row>

    <b-row v-if="$parent.event.groups && $parent.event.groups.length > 1">
      <b-col>
        <b-table
          striped
          hover
          show-empty
          stacked="sm"
          ref="userstab"
          :items="$parent.event.groups"
          :fields="groupFields"
          small
        >
          <template v-slot:cell(dname)="group">
            {{ group.item.dname }}
          </template>
          <template v-slot:cell(ctrl)="group">
            <b-button
              class="btn_reg_table"
              size="sm"
              v-if="group.item.dname != 'freeaccess'"
              @click="group_delete(group.item)"
              variant="danger"
            >
              Delete
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <!-- Ticketing CRUD -->
    <div style="margin-top:20px"  v-if="$parent.event.groups.length > 0">
    
     Manage Tickets
      <b-row>
        <b-col sm="4">
          <b-button size="sm" @click="ticket_create" variant="primary">
            New Ticket
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            striped
            hover
            show-empty
            stacked="sm"
            :items="tkts"
            :fields="ticketFields"
            small
          >
            <template v-slot:cell(ctrl)="tkt">
              <b-button
                variant="primary"
                class="btn_tag"
                size="sm"
                @click="tkt_edit(tkt.item, tkt.index)"
              >
                Edit
              </b-button>

              <confirm-del 
             variant="danger"
             v-on:confirmed-delete="tkt_delete(tkt.item,tkt.index)"
             >
             </confirm-del >
            </template>
            <template v-slot:cell(t)="tkt">
              {{ tkt.item.t }}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-modal id="bv-tkt-edit" size="lg" :title="edit_modal_title" hide-footer>
         <b-row>
            <b-col sm="4">
           Status
          </b-col>
         <b-col sm="4">
        <b-form-checkbox v-model="tkt.status"  value="active" class name="check-button" switch> 
          {{(tkt.status=="active")  ? "Active": "Deactive"}}
        </b-form-checkbox>
         </b-col>
         </b-row>
        
       <b-row>
         <b-col sm="4">
           Free Access
         </b-col>
         <b-col sm="4">
        <b-form-checkbox v-model="tkt.groups" @change="freeSelected" class  value="freeaccess" name="check-button" switch>
         </b-form-checkbox>
         </b-col>
       </b-row>
       
        <b-row>
          <b-col sm="4"> Ticket Type </b-col>
          <b-col sm="4">
            <b-form-checkbox
              v-model="tkt.type"
              @change="typeSelected"
              class
              value="addon"
              name="check-button"
              switch
            >
              Addon
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4"> Ticket name </b-col>
          <b-col class="rep_field">
            <b-input
              size="sm"
              class="rep_edit_input"
              :state="tkt.name.length > 0"
              placeholder="Ticket name"
              v-model="tkt.name"
            >
            </b-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="4"> Select Tiers </b-col>
          <b-col class="rep_field">
            <b-form-checkbox
              v-for="option in $parent.event.groups"
              v-model="tkt.groups"
              :key="option.dname"
              :value="option.dname"
              name="groups"
            >
              {{ option.dname }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row >
          <b-col sm="4"> Price </b-col>
          <b-col class="rep_field">
            <b-input
              size="sm"
              class="rep_edit_input"
              :state="validprice(tkt.price)"
              placeholder="Amount"
              v-model="tkt.price"
            >
            </b-input>
          </b-col>
        </b-row>
        <div style="padding: 1vw 0px">
          <b-button-group class="">
            <b-button
              size="sm"
              variant="primary"
              @click="save_ticket"
               :disabled="tkterr"
            >
              Save
            </b-button>
          </b-button-group>
          <b-button-group class="float-right">
            <b-button
              size="sm"
              @click="$bvModal.hide('bv-tkt-edit')"
              variant="danger"
            >
              Cancel
            </b-button>
          </b-button-group>
        </div>
      </b-modal>
    </div>
     <label
      v-if="
       $parent.event.groups.length<1" style="margin-top:20px; textalign:center"
      ><b
        >No tiers in this event. Please make sure at least one tier is
        created to create tickets.</b
      ></label
    >

    <!-- <b-row class="mt-4" style="border-top: solid 1px black" /> -->

    
  </b-container>
</template>
<script>
import { sync } from "vuex-pathify";
// import DatePicker from "vue2-datepicker";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import UploadImage from "../components/UploadImage";
import ConfirmDel from "../components/ConfirmDel";


export default {
  name: "update_event",
  data() {
    return {
      
     tkt_enable:false, 
     Active:true, 
     groupFields: [
       {key: "dname", label: ""},
       {key: "ctrl", label: ""},
     ],
     tier_name: "",
    
     tkt:{id:"", name:"", groups:[], price:"", type:"", status:"active"},
     tkts:[],
     edit_modal_title: "Edit",
     ticketFields: [
          {key: "ctrl", label: ""},
          {key: "name", label: "Ticket Name"},
          {key: "type", label: "Ticket Type"},
          {key: "groups", label: "Groups assigned", formatter: value => {
              return value.join()
            }},
          {key: "price", label: "Price"},
          {key:"status", label:"Status"},
        ],
      is_free:false,
      tkttype:"",
      tktmod:"",
      tktindex:""
    }
  },
  components: {
     ConfirmDel
  },
  created() {
  },
  computed: {
    tkterr :function(){
      let vue = this;
      if (!vue.tkt.name) {
        return true
      } else if (!vue.validprice(vue.tkt.price)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    validprice: function(price) {
      if (price.length == 0){
        return false;
      } else if(isNaN(price)) {
        return false;
      }
      return true;
    },
    to_disp_name: function (name) {
      var idx = name.indexOf("-");
      var subs = name.substring(idx + 1);
      return subs.replaceAll("-", " ");
    },
    group_add: function () {
      let vue = this;
      let ev = vue.$parent.event;
      ev.groups.forEach((item) => {
        console.log(item.dname);
      });
      window.wss_send(vx, "adm_event_add_group", {
        event: {
          id: ev.id,
        },
        group: {
          name:  ev.id + "-" + vue.tier_name.replaceAll(" ", ""),
        },
      });
    },
    group_delete: function (g) {
      let vue = this;
      let ev = vue.$parent.event;
      let tierExists=false;
      vue.tkts.forEach((item) => {
        if (item.groups.includes(g.dname)) {
          tierExists = item.groups.includes(g.dname);
        }
      });
      if (!tierExists) {
        vue.$bvModal
          .msgBoxConfirm("Are you sure you want to delete this item?", {
            title: "Confirm delete",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Delete",
            cancelTitle: "Cancel",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              window.wss_send(vx, "adm_event_rem_group", {
                event: {
                  id: ev.id,
                },
                group: {
                  name: g.name,
                },
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
         vue.$parent.toast("err","You cannot delete a Tier while in use by a Ticket.");
       return false;
      }
    },
    
    event_setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
      let groups = vue.$parent.event.groups;
      vue.startdate = new Date(vue.$parent.event.startep);
      vue.enddate = new Date(vue.$parent.event.endep);
    //   vue.is_pub = vue.$parent.event.is_pub;
      vue.coord_list = [];
      if (vue.$parent.event.coord) {
        Object.keys(vue.$parent.event.coord).forEach(function (k) {
          vue.coord_list.push(k.toLowerCase());
        });
      }
      vue.fetchtickets();
    },
    ticket_create: function (event) {
      let vue = this;
      event.preventDefault();
      vue.tktmod = "";
      vue.is_free = false;
      vue.tkt_enable=false, 
      vue.active = false, 
      vue.tkt.id = utils.new_id(this.$parent.event);
      vue.tkt.name = "";
      vue.tkt.groups = [];
      vue.tkt.price = "";
      vue.tkt.type = "";
      vue.edit_modal_title = "New Ticket";
      vue.$bvModal.show("bv-tkt-edit");
    },
    tkt_edit:function(t,i) {
      console.log("index",i)
      console.log("t..",t.status)
      console.log("t..",t.price)

      let vue = this;
      vue.tktmod = "edit";
      vue.tktindex = i;
      vue.edit_modal_title = "Edit Ticket";
      vue.tkt = {"id":t.id,"name": t.name,"groups":t.groups,"price":t.price,"type":t.type, "status":t.status};
      vue.freeSelected();
      vue.$bvModal.show('bv-tkt-edit')
    
    },
    tkt_delete: function (t, i) {
      let vue = this;
     vue.tktmod="delete";
     vue.tkts.splice(i,1);
     vue.save_ticket(); 
    },

    save_ticket: function (i = 0) {
      let vue = this;
     
      let has_err = false;
      if (vue.tkt.name.length == 0 && vue.tktmod != "delete") { has_err = true; }
      // console.log("old", vue.tkts);
      if (has_err) {
        return;
      }
      if (vue.tktmod === "") {
        vue.tkts.push(vue.tkt);
      } else if (vue.tktmod == "edit") {
        vue.tkts[vue.tktindex] = vue.tkt;
      }
       if(vue.tkt.status==""){
        vue.tkt.status="deactive"
      }
      window.wss_send_cb(
        vx,
        "adm_event_set_part",
        {
          event: {
            id: vue.$parent.event.id,
            field: "tickets",
            obj: {
              id: 1,
              t: vue.tkts,
            },
          },
        },
        function (msg) {
          console.log("set_part done");
          vue.fetchtickets();
        }
      );

      vue.$bvModal.hide("bv-tkt-edit");
    },

    fetchtickets: function () {
      let vue = this;
      window.wss_send_cb(
        vx,
        "adm_event_get_part",
        {
          event: {
            id: vue.$parent.event.id,
            field: "tickets",
            fid: 1,
          },
        },
        function (msg) {
          console.log(msg);
          vue.tkts = [];
          if (!msg || !msg.data || !msg.data.obj) {
            return;
          }
          let tkt = msg.data.obj[0];
          if (!tkt || !tkt.t) {
            return;
          }
          vue.tkts.id = tkt.id;
          tkt.t.forEach(function (t) {
            vue.tkts.push(t);
          });
          console.log("get_part done", vue.tkts);
        }
      );
    },
    freeSelected: function(){
        let vue = this;
        console.log(vue.tkt.groups);
        if(vue.tkt.groups.includes('freeaccess')){
          vue.is_free=false;
        } else{
          vue.is_free=true;
        }
      
    },
     typeSelected: function(){
        let vue = this;
        vue.tkt.type = vue.tkt.type=="addon"  ? "addon" :  " ";    
         vue.is_free=false; 
        if (vue.tkt.type=="addon" && vue.tkt.groups.indexOf('freeaccess') !== -1) {
          vue.tkt.groups.splice(vue.tkt.groups.indexOf('freeaccess'), 1);
        }
        console.log("tkt.type : ",vue.tkt.type)
    }
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx, "updateevent");
  },
  watch: {
    "$parent.event.id": function (to, from) {
      this.event_setup();
    },
  },
  mounted() {
    let vue = this;
    vue.event_success = false;
    vue.event_setup();
    window.wss_open(vx, {
      acc: vue.$parent.acc,
      uid: vx.user.id,
      routes_id: "updateevent",
      routes: {
       
        adm_event_rem_group: function (msg) {
          if (msg.data.error) {
            console.log(msg.data.error);
            return;
          }
          utils.set_groups(vue.$parent.event, msg.data.event.groups);
          return;
        },
        adm_event_add_group: function (msg) {
          vue.tier_name = "";
          if (msg.data.error) {
            console.log(msg.data.error);
            return;
          }
          utils.set_groups(vue.$parent.event, msg.data.event.groups);
          return;
        },
      },
    });
  },
};
</script> 
<style>
.row {
  padding-top: 10px;
}
.error {
  color: red;
  padding-top: 10px;
  font-weight: 500;
}
.message {
  font-weight: 500;
  color: red;
  padding-top: 5px;
}
.para {
  white-space: pre-wrap;
}
.btn{
  margin-bottom: 0px;
}
</style>
